import React from 'react';
import type { MdComponentIndexProps } from '../type';
import MarkdownListItem from './MarkdownListItem';

function MarkdownList(
  props: React.PropsWithChildren<
    {
      ordered?: boolean | null;
      start?: any | null;
    } & MdComponentIndexProps
  >,
) {
  const start = typeof props.start !== 'number' ? 0 : parseInt(String(props.start), 0);
  let count = -1;
  return (
    <div
      data-type="list"
      className="markdown-child-root"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      {React.Children.map(props.children, (item) => {
        if (
          React.isValidElement(item) &&
          (item.type === MarkdownListItem ||
            (typeof item.type === 'function' &&
              (item.type as any).displayName === MarkdownListItem.displayName))
        ) {
          count += 1;
          return <MarkdownListItem {...item.props} ordered={props.ordered} index={start + count} />;
        }
        return null;
      })}
    </div>
  );
}

export default MarkdownList;
